export const setHeaders = headers => {
  return { type: 'SET_HEADERS', headers };
};
